export const getUserReports = state => state.userData.userReports;

export const getUserType = state => state.userData.userType;
export const getLaunchPage = state => state.userData.launchPage;

export const getIsAdmin = state => state.userData.isAdmin;

export const getRoles = state => state.userData.roles;

export const getFailedReportsDefinitions = state => state.userData.failedReportsDefinitions;

export const getCurrentSavedUserReportId = state => state.userData.currentReportSavedId;

export const getCurrentReport = (state) => {
  let currentReport = getUserReports(state)
    .map(group => group.reportCategories)
    .reduce((a, b) => a.concat(b), [])
    .map(rc => (rc.reportsWithMainCategoryReference || [])
      .concat(rc.reportsWithoutMainCategoryReference || []))
    .reduce((a, b) => a.concat(b), [])
    .find(report => report.reportCode === state.userData.currentReportCode);
  if (currentReport && currentReport.saved && currentReport.saved.length) {
    currentReport = {
      ...currentReport,
      saved: currentReport.saved.map(saved => ({
        id: saved.id,
        reportCode: currentReport.reportCode,
        selectionName: saved.selectionName,
        ...JSON.parse(saved.requestBody),
      })),
    };
  }
  if (currentReport && currentReport.recent) {
    currentReport = {
      ...currentReport,
      recent: ({
        id: currentReport.recent.id,
        reportCode: currentReport.reportCode,
        ...JSON.parse(currentReport.recent.requestBody),
      }),
    };
  }
  return currentReport;
};

export const getCurrentReportCode = state =>
  state.userData.currentReportCode;

export const getRequestParams = state =>
  state.reporting[getCurrentReportCode(state)].requestParams;

export const getScSets = state => state.userData.scSets;

export const getCreatedReqParams = state => state.userData.savedReqParams;

export const getRecentSelections = state => state.userData.recentSelections;

export const getLastSelections = state => state.userData.lastSelections;

export const getUserLoaded = state => state.userData.userLoaded;

export const getLastSelectionsLoaded = state => state.userData.lastSelectionsLoaded;
